import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";
import { ProductCard } from "./ProductCard";

export const NewArrivalsGrid = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/products?sort=new&limit=8")
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      className="py-20 md:py-28 bg-white border-y border-jow-navy/10"
      data-testid="home-new-arrivals"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-12 gap-4">
          <div>
            <span className="label-overline text-jow-gold">Just In</span>
            <h2 className="font-display text-4xl md:text-5xl mt-2 text-jow-navy">
              New Arrivals
            </h2>
          </div>
          <Link
            to="/shop?sort=new"
            className="label-overline text-jow-pink hover:underline"
            data-testid="new-arrivals-view-all"
          >
            View all →
          </Link>
        </div>

        {loading && (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-testid="new-arrivals-loading">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] bg-jow-cream border border-jow-navy/10 animate-pulse" />
            ))}
          </div>
        )}
        {!loading && (
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-5"
          >
            {items.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </motion.div>
        )}
      </div>
    </section>
  );
};
